"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var updateFavoritesUserOption_1 = require("./updateFavoritesUserOption");
var moveDragAndDroppableItem_1 = require("owa-dnd/lib/utils/moveDragAndDroppableItem");
var owa_mail_favorites_store_1 = require("owa-mail-favorites-store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Move the favorite node before the specified node
 * @param favoriteIdToUpdate the id to be moved
 * @param destinationFavoriteId the id to be inserted before
 */
exports.default = legacy_1.action('moveFavoriteToPosition')(legacy_1.select({
    orderedFavoritesNodeIds: function () { return owa_mail_favorites_store_1.favoritesStore.orderedFavoritesNodeIds; },
})(function moveFavoriteToPosition(favoriteIdToUpdate, destinationFavoriteId, state) {
    var orderedFavoritesNodeIds = state.orderedFavoritesNodeIds;
    var fromIndex = orderedFavoritesNodeIds.indexOf(favoriteIdToUpdate);
    var toIndex = orderedFavoritesNodeIds.indexOf(destinationFavoriteId);
    // Move the element from the old position to the new position in the array
    moveDragAndDroppableItem_1.default(orderedFavoritesNodeIds, fromIndex, toIndex);
    // Update user options service which is used by OWA
    updateFavoritesUserOption_1.default();
}));
//# sourceMappingURL=moveFavoriteToPosition.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/moveFavoriteToPosition.js
// module id = 4647
// module chunks = 14